module.exports = "<div ui-view=step></div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/governance/states/governance/insurance/insurance.html
// module id = 618
// module chunks = 0